import { ValidationRules } from 'aurelia-validation';

ValidationRules.customRule(
    'number',
    (value, obj) => value === null || value === undefined || /^\d+$/.test(value),
    'I18N_VOLTOSPA_VALIDATION_NUMBER'
);